import axios from 'axios';

const axiosInstance = axios.create();
axiosInstance.defaults.showLoader = false;
axiosInstance.defaults.nameLoader = '';

export default axiosInstance;
